import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/theme.css';
import App from './App';
import { DashboardProvider } from './context/DashboardContext';
import { WorkspaceProvider } from './integrationQA/context/WorkspaceContext';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <WorkspaceProvider>
        <DashboardProvider>
          <App />
        </DashboardProvider>
      </WorkspaceProvider>
    </BrowserRouter>
  </React.StrictMode>
);
